module.exports = __webpack_public_path__ + "static/premium-kit-425e0b93c64c6a5b9ec31aef37204143.png";